import React, {Component} from 'react'
import StatusStyle from '../../../shared/StatusStyle'
import PropTypes from 'prop-types'
import {Button, Empty, Modal} from 'antd'
import markAsUnPrinted from '../actions/markAsUnPrinted'
import deleteBasketNumber from '../actions/deleteBasketNumber'
import printText from '../../../../helpers/printText'
import requestPrint from '../../../../helpers/print'
import {printQrOrder} from "../../../../services/api/3dApi"
import ThreadColorImage from '../../../batch/components/data/ThreadColorImage'
import { isAbsoluteUrl } from '../../../batch/components/data/ThreadColorImage'

class OrderItemDetailsContainer extends Component {
    state = {
        visible: false,
    }

    _showModal = () => {
        this.setState({
            visible: true,
        })
    }

    _hideModal = () => {
        this.setState({
            visible: false,
        })
    }

    componentDidMount() {
        document.addEventListener('keydown', this._handleOnKeyboard)
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this._handleOnKeyboard)
    }

    _handleOnKeyboard = (e) => {
        const {keyCode} = e

        if (keyCode === 81) {
            return this._handleClickPrintQR()
        }

        if (keyCode === 71) {
            return this._handleClickPrintBasketNumber()
        }
    }

    _handleClickPrint = async () => {
        const {template} = this.props
        const {_id} = template

        await markAsUnPrinted(_id)

        this.props.onCleanPage()
    }

    _handleClickRemoveBasket = async () => {
        const {template} = this.props
        const {_id} = template

        await deleteBasketNumber(_id)

        this.props.onCleanPage()
    }

    _handleClickPrintBasketNumber = e => {
        e && e.preventDefault()

        const {basket_number, marketplace, item_number} = this.props.template
        if (!basket_number) return false
        printText(basket_number, `#${marketplace}_${item_number}`)

        this.props.onCleanPage()
    }

    _handleClickPrintQR = e => {
        e && e.preventDefault()

        const {marketplace, item_number} = this.props.template

        requestPrint(printQrOrder(`${marketplace}_${item_number}`))

        this.props.onCleanPage()
    }


    render() {
        const {template} = this.props
        const {
            mock_up_front,
            mock_up_back,
            marketplace,
            item_number,
            size,
            type,
            production_status,
            basket_number,
            preview_image,
            thread_color_note = '',
        } = template


        return (
            <div className='OrderItemDetailsContainer'>
                <div className='row'>
                    <div className='col-6'>
                        <div className='row'>
                            {
                                !mock_up_front && !mock_up_back
                                    ?
                                    <div className='col-12'>
                                        <Empty description='Không có mockup'/>
                                    </div>
                                    :
                                    <>
                                        <div className='col-6'>
                                            <div>Front</div>
                                            {
                                                mock_up_front &&
                                                <div className='MockUp'>
                                                    <img src={mock_up_front} alt='front'/>
                                                </div>
                                            }
                                        </div>

                                        <div className='col-6'>
                                            <div>Back</div>
                                            {
                                                mock_up_back &&
                                                <div className='Mockup'>
                                                    <img src={mock_up_back} alt='back'/>
                                                </div>
                                            }
                                        </div>
                                    </>
                            }
                        </div>
                    </div>

                    <div className='col-6'>
                        <div className='row mb-2'>
                            <div className='col-4'>Số đơn:</div>
                            <div className='col-8'>{`#${marketplace}_${item_number}`}</div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-4'>Loại sản phẩm:</div>
                            <div className='col-8'>{type}</div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-4'>Size:</div>
                            <div className='col-8'>{size}</div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-4'>Trạng thái in:</div>
                            <div className='col-8'><StatusStyle status={production_status}/></div>
                        </div>

                        {
                            preview_image &&
                            <div className='row mb-2'>
                                <div className='col-4'>File in:</div>
                                <div className='col-8'>
                                    <span className='text-primary cursor-pointer' onClick={this._showModal}>View</span>
                                </div>
                            </div>
                        }

                        {
                            basket_number &&
                            <div className='row mb-2'>
                                <div className='col-4'>Mã giỏ</div>
                                <div className='col-8'>
                                    <span className='mr-3'>{basket_number}</span>
                                    {/*<Button onClick={this._handleClickPrintBasketNumber} size='large'>In số giỏ</Button>*/}
                                </div>
                            </div>
                        }

                        {
                            !!thread_color_note &&
                            <div className='row mb-2' style={{ color: '#ee2b4f' }}>
                                <div className='col-4'>Màu chỉ yêu cầu:</div>
                                <div className='col-8'>
                                    {!!isAbsoluteUrl(thread_color_note) ?
                                        <ThreadColorImage ImageUrl={thread_color_note} /> :
                                        thread_color_note
                                    }
                                </div>
                            </div>
                        }

                        <div className='mt-3'>
                            {/*<Button icon='printer' onClick={this._handleClickPrint}*/}
                            {/*        disabled={production_status === 'unprinted'} size='large'>In lại</Button>*/}

                            {/*<Button icon='delete' type='danger' ghost className='ml-5'*/}
                            {/*        onClick={this._handleClickRemoveBasket} disabled={!basket_number} size='large'>Hoàn*/}
                            {/*    thành lỗi</Button>*/}
                        </div>

                        <div className="mt-5">
                            {/*<Button icon='qrcode' type='success'*/}
                            {/*        onClick={this._handleClickPrintQR} size='large'>In QR</Button>*/}
                        </div>
                    </div>
                </div>

                <Modal visible={this.state.visible} closable={false} centered={true} footer={null} width={1200}
                       onCancel={this._hideModal}>
                    <img src={preview_image} alt='File in' className='d-block m-auto'/>
                </Modal>
            </div>
        )
    }
}

OrderItemDetailsContainer.propTypes = {
    template: PropTypes.object.isRequired,
    onCleanPage: PropTypes.func.isRequired,
}

export default OrderItemDetailsContainer
